import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Bookmark, Cash, Sizes } from "@/components/icon/IconList";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { CASH_INDEX_PAGE, PASSES_LANDING } from "@/settings/constant";
import { Divider, Typography } from "@bookips/sds";
import Link from "next/link";
import { useHomeSwitchStore } from "src/store/homeSwitch.store";
import IconV1 from "../../../icon/Icon";
const SubGNBPromotion = ()=>{
    const { homeType , subject  } = useHomeSwitchStore();
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ _jsxs(Link, {
                href: "".concat(PASSES_LANDING, "/").concat(homeType, "?subject=").concat(subject),
                onClick: ()=>{
                    mixpanelEvent("Home Quick Button Clicked", {
                        "Button Type": "Pass",
                        "Button Name": "이용권 구매",
                        url: PASSES_LANDING
                    });
                },
                className: "flex h-8 items-center gap-1 rounded rounded-sm px-3 py-1.5 transition-colors hover:bg-gray-50",
                children: [
                    /*#__PURE__*/ _jsx(IconV1, {
                        icon: Bookmark,
                        size: Sizes.xmedium,
                        color: "currentColor",
                        className: "text-primary-main"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle2",
                        className: "text-primary-main font-semibold",
                        children: "이용권 구매"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Divider, {
                orientation: "vertical",
                className: "h-3.5 self-center"
            }),
            /*#__PURE__*/ _jsxs(Link, {
                href: CASH_INDEX_PAGE,
                onClick: ()=>{
                    mixpanelEvent("Home Quick Button Clicked", {
                        "Button Type": "Cash",
                        "Button Name": "캐시 충전",
                        url: CASH_INDEX_PAGE
                    });
                },
                className: "flex h-8 items-center gap-1 rounded-sm px-3 py-1.5 transition-colors hover:bg-gray-50",
                children: [
                    /*#__PURE__*/ _jsx(IconV1, {
                        icon: Cash,
                        size: Sizes.xxmedium,
                        color: "currentColor",
                        className: "text-primary-main"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle2",
                        className: "text-primary-main font-semibold",
                        children: "캐시 충전"
                    })
                ]
            })
        ]
    });
};
export default SubGNBPromotion;
